import React, { useContext } from 'react';
import { useNavigate } from '@thd-olt-component-react/router';
import { Button, Row, Col } from '@thd-olt-component-react/core-ui';
import { clickEvents } from '../../../utils/analytics';
import { EXP_ROUTES, JOB_POSTING_STATUS } from '../../../utils/constants';
import { JobPostingContext } from '../../../contexts/JobPostingContext';
import { useStore } from '../../../store';
import { jobPostingValidators } from '../../../utils/validations';
import { capitalizesFirstLetters } from '../../../utils/formatters';

export const CreateJobPostingButtons = ({ setShowErrors, scrollToError }) => {
  const {
    jobPostingStore: { saveJobPosting, togglePublishJobPostingModal, toggleUnsavedWorkModal }
  } = useStore();

  const {
    editorModeActive, canPublishJobPosting, editedJobPosting, canSaveAsDraft
  } = useContext(JobPostingContext);

  const navigate = useNavigate();

  const composeDataForSubmit = (status) => {
    return {
      ...editedJobPosting,
      companyUrl: editedJobPosting.companyUrl || null,
      sharing: status === 'ACTIVE',
      title: capitalizesFirstLetters(editedJobPosting.title),
      yearsOfExperience: jobPostingValidators.yearsOfExperience(editedJobPosting) ? editedJobPosting.yearsOfExperience : null,
      status
    };
  };

  const handleClose = (jobPostingId) => {
    togglePublishJobPostingModal();
    toggleUnsavedWorkModal();
    if (jobPostingId !== undefined) {
      window.setTimeout(() => {
        navigate(EXP_ROUTES.JOB_POSTING(jobPostingId));
      }, 100);
    } else {
      navigate(EXP_ROUTES.JOB_POSTINGS);
    }
  };

  const handleSaveAsDraft = () => {
    if (canSaveAsDraft()) {
      clickEvents.postingDetailsModifications('save as draft');
      saveJobPosting(composeDataForSubmit(JOB_POSTING_STATUS.DRAFT), handleClose);
    } else {
      setShowErrors({ draft: true, publish: true });
      scrollToError();
    }
  };

  const handlePublish = () => {
    if (canPublishJobPosting()) {
      clickEvents.postingDetailsModifications('publish');
      togglePublishJobPostingModal({
        ...editedJobPosting,
        title: capitalizesFirstLetters(editedJobPosting.title)
      });
    } else {
      setShowErrors({ draft: true, publish: true });
      scrollToError();
    }
  };

  return (
    <div className="create-job-posting__button-container">
      <Row className="create-job-posting__button-container-grid">
        <Col xs="2" className="create-job-posting__button-cancel">
          <Button
            outline
            onClick={() => toggleUnsavedWorkModal(editedJobPosting)}
            style={{ fontSize: '18px', lineHeight: '20px', fontWeight: 'bold' }}
          >
            Cancel Posting
          </Button>
        </Col>
        <Col xs="5" />
        <Col xs="2">
          <Button
            onClick={handleSaveAsDraft}
            data-testid="open-complete-job-posting-modal-jpp"
            outline
            style={{ fontWeight: 700 }}
          >
            Save as Draft
          </Button>
        </Col>
        <Col xs="3">
          <Button
            outline={!editorModeActive}
            onClick={handlePublish}
            data-testid="open-publish-job-posting-modal-jpp"
            style={{ fontWeight: 700 }}
          >
            Publish Posting
          </Button>
        </Col>
      </Row>
    </div>
  );
};
